import React from 'react';

import { Tooltip } from '@mui/material';

import useStyles from './styles';

interface Props {
    label: string;
    tooltip?: string;
    color?: 'default' | 'blue';
    className?: string;
}

const Tag: React.FC<Props> = ({ label, color = 'default', tooltip = null, className }) => {
    const { classes, cx } = useStyles();

    return (
        <Tooltip title={tooltip}>
            <span
                className={cx(
                    classes.root,
                    {
                        [classes._default]: color === 'default',
                        [classes._blue]: color === 'blue'
                    },
                    className
                )}
            >
                {label}
            </span>
        </Tooltip>
    );
};

export default Tag;
